import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
type ModalType = 'privacy' | 'terms' | 'legal' | null;
const modalContent: Record<Exclude<ModalType, null>, {
  title: string;
  body: string[];
}> = {
  privacy: {
    title: 'Política de Privacidad',
    body: ['En Infancia Analógica nos comprometemos a proteger tu privacidad y la de tu familia.', 'Datos que recopilamos: Únicamente recopilamos la información necesaria para procesar tu compra (nombre, correo electrónico y datos de pago). No almacenamos datos de tarjetas de crédito; estos son procesados de forma segura por nuestro proveedor de pagos.', 'Uso de la información: Tu correo electrónico se utiliza exclusivamente para enviarte el producto adquirido y actualizaciones relacionadas. No compartimos, vendemos ni cedemos tu información personal a terceros.', 'Cookies: Nuestro sitio puede utilizar cookies técnicas y de análisis para mejorar tu experiencia de navegación. Puedes desactivarlas en la configuración de tu navegador.', 'Derechos del usuario: Puedes solicitar en cualquier momento el acceso, rectificación o eliminación de tus datos personales enviándonos un correo electrónico.', 'Esta política puede actualizarse periódicamente. La fecha de última actualización se indicará en esta misma página.']
  },
  terms: {
    title: 'Términos y Condiciones',
    body: ['Al adquirir cualquier producto de Infancia Analógica, aceptas los siguientes términos:', 'Producto digital: Recibirás acceso inmediato al material en formato PDF tras confirmar el pago. Al tratarse de un producto digital de descarga inmediata, no se aceptan devoluciones fuera del periodo de garantía.', 'Garantía "Mamá Feliz": Dispones de 7 días naturales desde la fecha de compra para solicitar un reembolso completo si el producto no cumple tus expectativas. Basta con enviar un correo electrónico indicando tu solicitud.', 'Uso personal: El contenido adquirido es para uso personal y familiar. Queda prohibida su reproducción, distribución o reventa total o parcial sin autorización expresa.', 'Propiedad intelectual: Todos los textos, diseños, metodologías e imágenes son propiedad de Infancia Analógica y están protegidos por las leyes de propiedad intelectual.', 'Actualizaciones: Las actualizaciones del material durante el año 2026 están incluidas en tu compra sin coste adicional.', 'Nos reservamos el derecho de modificar estos términos. Los cambios se publicarán en esta página.']
  },
  legal: {
    title: 'Aviso Legal',
    body: ['Infancia Analógica es un proyecto de contenido educativo orientado a familias.', 'Responsabilidad: La información proporcionada en nuestros materiales tiene carácter informativo y educativo. No sustituye el consejo profesional de pediatras, psicólogos infantiles u otros especialistas de la salud.', 'Resultados: Los resultados descritos en nuestra página de venta se basan en experiencias reales, pero pueden variar según cada familia y circunstancia. No garantizamos resultados específicos.', 'Edad recomendada: El método está diseñado para familias con hijos de entre 2 y 12 años. La aplicación de las estrategias queda bajo la responsabilidad de los padres o tutores legales.', 'Legislación aplicable: Este sitio web y sus condiciones se rigen por la legislación vigente. Cualquier controversia será sometida a los tribunales competentes.', 'Última actualización: Marzo 2026.']
  }
};
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="py-6 px-4 bg-navy text-center" data-id="element-27">
        <p className="text-sm text-warm-medium" data-id="element-28">
          © {new Date().getFullYear()} Infancia Analógica. Todos los derechos
          reservados.
        </p>
        <div className="mt-2 flex items-center justify-center gap-3 text-xs text-warm-medium/70" data-id="element-29">
          <button onClick={() => setActiveModal('privacy')} className="hover:text-cream transition-colors cursor-pointer" data-id="element-30">
            Política de Privacidad
          </button>
          <span data-id="element-31">·</span>
          <button onClick={() => setActiveModal('terms')} className="hover:text-cream transition-colors cursor-pointer" data-id="element-32">
            Términos y Condiciones
          </button>
          <span data-id="element-33">·</span>
          <button onClick={() => setActiveModal('legal')} className="hover:text-cream transition-colors cursor-pointer" data-id="element-34">
            Aviso Legal
          </button>
        </div>
      </footer>

      {/* Modal */}
      <AnimatePresence data-id="element-35">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-navy/60 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-36">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.25
        }} className="bg-cream rounded-2xl shadow-2xl max-w-lg w-full max-h-[80vh] overflow-hidden flex flex-col" onClick={e => e.stopPropagation()} data-id="element-37">
              {/* Header */}
              <div className="flex items-center justify-between p-5 border-b border-cream-dark" data-id="element-38">
                <h2 className="text-xl font-serif font-bold text-navy" data-id="element-39">
                  {modalContent[activeModal].title}
                </h2>
                <button onClick={() => setActiveModal(null)} className="w-8 h-8 flex items-center justify-center rounded-full bg-cream-dark hover:bg-terracotta/10 transition-colors text-warm-medium hover:text-navy" data-id="element-40">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" data-id="element-41">
                    <path d="M4 4l8 8M12 4l-8 8" data-id="element-42" />
                  </svg>
                </button>
              </div>

              {/* Body */}
              <div className="p-5 overflow-y-auto space-y-4" data-id="element-43">
                {modalContent[activeModal].body.map((paragraph, i) => <p key={i} className="text-sm text-warm-dark leading-relaxed" data-id="element-44">
                    {paragraph}
                  </p>)}
              </div>

              {/* Footer */}
              <div className="p-4 border-t border-cream-dark" data-id="element-45">
                <button onClick={() => setActiveModal(null)} className="w-full py-2.5 bg-navy text-cream text-sm font-bold rounded-xl hover:bg-navy-light transition-colors" data-id="element-46">
                  Cerrar
                </button>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}